import User, {Role} from '../core/auth/user';

export class ClientMelding {

  static deserialize(dto: ClientMeldingDto): ClientMelding {
    return new ClientMelding(
      dto.id,
      dto.auteurId,
      dto.auteurRol as Role,
      dto.clientId,
      dto.content,
      new Date(dto.creatieTijdstip),
      new Date(dto.laatstGewijzigdeTijdstip),
    );
  }

  constructor(private id: string,
              private auteurId: string,
              private auteurRol: Role,
              private clientId: string,
              private content: string,
              private creatieTijdstip: Date,
              private laatstGewijzigdeTijdstip: Date,
  ) {
  }

  getId(): string {
    return this.id;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  hasAuteurId(auteurId: string): boolean {
    return this.auteurId === auteurId;
  }

  getAuteurRol(): Role {
    return this.auteurRol;
  }

  hasAuteurRol(auteurRol: Role): boolean {
    return this.auteurRol === auteurRol;
  }

  isFromRegioverantwoordelijke(): boolean {
    return this.hasAuteurRol(Role.REGIOVERANTWOORDELIJKE);
  }

  getClientId(): string {
    return this.clientId;
  }

  getContent(): string {
    return this.content;
  }

  getCreatieTijdstip(): Date {
    return this.creatieTijdstip;
  }

  getLaatstGewijzigdeTijdstip(): Date {
    return this.laatstGewijzigdeTijdstip;
  }

  isEditableBy(user: User): boolean {
    return this.hasAuteurId(user.id)
      || (this.isFromRegioverantwoordelijke() && user.isRegioverantwoordelijke());
  }

  isDeletableBy(user: User): boolean {
    return this.hasAuteurId(user.id) || user.isRegioverantwoordelijke();
  }
}

export interface ClientMeldingDto {
  id: string;
  auteurId: string;
  auteurRol: string;
  clientId: string;
  content: string;
  creatieTijdstip: string;
  laatstGewijzigdeTijdstip: string;
}
